<template>
  <div class="home">
    <div class="header">
      <div class="tab">
        <span v-for="item in tab" :key="item.value"
          class="item" :class="{ active: item.value === selectKey }"
          @click.stop="select(item.value)"
          @touchstart="handleTouchStart"
          @touchend="handleTouchEnd(item.value)"
          >{{ item.name }}</span>
      </div>

      <i class="search-icon" @click="search" />

      <div class="first-menu">
        <div class="add" @click="goToCenter"></div>
<!--         <i class="add" @click="toggleMenu" /> -->
        <!--  :class="{ show140: isShowMenu && token, show93: isShowMenu && !token, isZh }" -->
        <!-- <div class="second-menu" :class="{ 'show': isShowMenu }">
          <div v-for="(item, index) in secondMenu" :key="index" class="item" @click="chooseMenu(item.key)">
            <img :src="item.icon" />
            <span>{{ item.name }}</span>
          </div>
        </div> -->
      </div>
    </div>

    <div class="main">
      <keep-alive>
<!--        <long-video v-if="selectKey === 0" />-->
        <short-video :current="selectKey" @changeIndex="changeIndex" :doubleKey="doubleKey"/>
<!--        <home-novel :key="refreshKey" v-if="selectKey === 2" />-->
      </keep-alive>
    </div>

    <!--  初始动画  -->
    <div class="launch-page" v-if="!hasShowLaunch">
      <img class="launch-bg" :src="launchBg" />

      <img class="logo" :src="siteConfig.launchLogo" />

      <img class="title1" src="./assets/currentTimeZh.png" />
      <img class="title2" src="./assets/currentTimeEn.png" />

      <div class="current-time">{{ currenTime }}</div>

      <img class="title3" :src="siteConfig.launchTitle" />

<!--      <img v-if="publicConfig.start_pic" class="launch-bg" :src="publicConfig.start_pic" />-->

<!--      <template v-else>-->
<!--        <img class="launch-bg" :src="launchBg" />-->

<!--        <img class="logo" src="./assets/logo.png" />-->

<!--        <img class="title1" src="./assets/currentTimeZh.png" />-->
<!--        <img class="title2" src="./assets/currentTimeEn.png" />-->

<!--        <div class="current-time">{{ currenTime }}</div>-->

<!--        <img class="title3" src="./assets/launchTitle.png" />-->
<!--      </template>-->

      <div v-if="countDownTime" class="count-down">{{ countDownTime }}s</div>
      <div v-else class="enter" @click="launchPageFlag">{{ $t('homeEnter') }}</div>
    </div>

    <lang-selector v-model="isShowSelect" :isHome="true" />

<!--    图片弹窗-->
    <announcement :dialogType="1"
                  @canShowAnnouncementPic="flag => canShowAnnouncementPic = flag"
                  @closeType="type => announcementCloseType = type"
    />
<!--    应用弹窗-->
    <announcement :dialogType="2" @closeType="type => announcementCloseType = type" />
<!--    图文弹窗-->
    <announcement :dialogType="3" @closeType="type => announcementCloseType = type" />
    <HomeSkeleton v-if="isHomeShowSkeleton" />
  </div>
</template>

<script>
import { Tabs, TabPane } from 'mand-mobile';
import ShortVideo from './components/shortVideo';
// import LongVideo from './components/longVideo';
import LangSelector from '@components/langSelector';
import Announcement from '@components/announcement';

import { mapActions, mapState } from 'vuex';
// import HomeNovel from '@views/home/home/components/novel';
import { timeConversion } from '@/utils';
import launchBg from './assets/launchBg.jpg';
import HomeSkeleton from '@/components/Skeleton/homeSkeleton.vue';

export default {
  name: 'Home',
  components: {
    // HomeNovel,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    ShortVideo,
    // LongVideo,
    LangSelector,
    Announcement,
    HomeSkeleton
  },
  data () {
    return {
      selectKey: 1,
      isShowSelect: false,
      isShowMenu: false,
      countDownTime: 3,
      refreshKey: 0,
      touchStartTime: 0,
      lastTapTime: 0,
      doubleTapTimeout: 300,
      countDownTimer: null,
      doubleKey: 0,
      isCanRefresh: false,
      launchBg,
      canShowAnnouncementPic: false,
      announcementCloseType: ''
    };
  },
  computed: {
    ...mapState('home', ['hasShowLaunch', 'nation']),
    ...mapState('user', ['token']),
    ...mapState('publicStore', [
      'publicConfig',
      'picAnnouncement',
      'richText',
      'isShowAnnouncementPic',
      'isShowAnnouncementApp',
      'isShowAnnouncementRichText',
      'isHomeShowSkeleton'
    ]),
    tab () {
      return [
        // {
        //   name: this.$t('homeNovel'),
        //   value: 2
        // },
        // {
        //   name: this.$t('homeLongVideo'),
        //   value: 0
        // },
        {
          name: '热门',
          value: 0
        },
        {
          name: this.$t('homeRecommend'),
          value: 1
        },
        {
          name: '认证',
          value: 2
        }
      ];
    },
    secondMenu () {
      let menu = [
        // {
        //   key: 'nation',
        //   name: this.$t('homeChangeNation'),
        //   icon: require('./assets/langIcon.png')
        // },
        // {
        //   key: 'addFriend',
        //   name: this.$t('addFriend')',
        //   icon: require('./assets/addFriend.png')
        // },
        {
          key: 'app',
          name: this.$t('downloadApp'),
          icon: require('./assets/appIcon.png')
        }
      ];

      if (SITE_CHANNEL === 'cnTitok') {
        menu = [
          {
            key: 'app',
            name: this.$t('downloadApp'),
            icon: require('./assets/appIcon.png')
          }
        ];
      }

      if (this.token) {
        menu.unshift(
          {
            key: 'qrcode',
            name: '邀请分享',
            icon: require('./assets/qrcodeIcon.png')
          }
        );
      }

      return menu;
    },
    currenTime () {
      const time = new Date().getTime() / 1000;
      return timeConversion(time, 'hh:mm');
    },
    isHome () {
      return this.$route.path === '/home';
    }
  },
  beforeDestroy () {
    clearInterval(this.countDownTimer);
  },
  watch: {
    token () {
      this.refreshKey++;
    },
    nation () {
      console.log('natin change');
      this.refreshKey++;
    },
    hasShowLaunch (val) {
      // 只在首页, 并且启动页关闭后才弹
      if (this.picAnnouncement.length && this.isHome && val) {
        this.setIsShowAnnouncementPic(true);
      } else if (this.publicConfig.app_is_apply === '1' && this.isHome) {
        this.setIsShowAnnouncementApp(true);
      } else if (this.publicConfig.app_is_apply === '2' && this.richText.length && this.isHome) {
        this.setIsShowAnnouncementRichText(true);
      }
    },
    isShowAnnouncementPic (val) {
      // 只在首页弹
      setTimeout(() => {
        if (!val && this.canShowAnnouncementPic && this.isHome) {
          this.setIsShowAnnouncementPic(true);
        } else if (this.announcementCloseType === 'closeBtn') {
          if (!val && this.publicConfig.app_is_apply === '1' && this.isHome) {
            this.setIsShowAnnouncementApp(true);
          }
          if (!val && this.publicConfig.app_is_apply === '2' && this.richText.length && this.isHome) {
            this.setIsShowAnnouncementRichText(true);
          }
        }
      }, 100);
    },
    isShowAnnouncementApp (val) {
      // 只在首页弹
      setTimeout(() => {
        if (!val && this.richText.length && this.announcementCloseType === 'closeBtn' && this.isHome) {
          this.setIsShowAnnouncementRichText(true);
        }
      }, 100);
    }
  },
  activated () {
    const selectKey = this.$route.query.selectKey;
    if (selectKey) {
      this.selectKey = Number(selectKey);
    }
  },
  created () {
    this.countDown();
  },
  mounted () {
    if (this.token) {
      this.getFocusList();
    }
    const selectKey = this.$route.query.selectKey;
    if (selectKey) {
      this.selectKey = Number(selectKey);
    }
    this.$bus.$on('', () => this.refreshKey++);
  },
  methods: {
    ...mapMutations('home', ['setHasShowLaunch']),
    ...mapMutations('publicStore', [
      'setLoadingShowFlag',
      'setIsShowAnnouncementPic',
      'setIsShowAnnouncementApp',
      'setIsShowAnnouncementRichText'
    ]),
    ...mapActions('message', ['getFocusList']),
    select (key) {
      this.setLoadingShowFlag(true);
      setTimeout(() => {
        this.setLoadingShowFlag(false);
      }, 500);

      this.selectKey = key;
      this.isShowMenu = false;
    },
    goToCenter () {
      this.$router.push('/createCenter');
    },
    refreshList (value) {
      if (this.isCanRefresh) {
        return;
      }
      if (this.selectKey === value) {
        this.isCanRefresh = true;
        setTimeout(() => {
          this.isCanRefresh = false;
        }, 1000);
        // 调用刷新短视频列表的方法
        this.doubleKey = new Date().getTime();
        // this.$refs.shortVideoComponent.refresh();
      }
    },
    handleTouchStart () {
      this.touchStartTime = new Date().getTime();
    },
    handleTouchEnd (value) {
      const currentTime = new Date().getTime();
      const tapLength = currentTime - this.touchStartTime;
      if (tapLength < this.doubleTapTimeout && currentTime - this.lastTapTime < this.doubleTapTimeout) {
        this.refreshList(value);
      }
      this.lastTapTime = currentTime;
    },
    chooseMenu (key) {
      if (key === 'nation') {
        // this.$toast.info(this.$t('homeNoOpenNet'));
        this.isShowSelect = true;
      } else if (key === 'app') {
        this.download();
      } else if (key === 'qrcode') {
        this.$router.push('/invite');
      }
      this.toggleMenu();
    },
    toggleMenu () {
      this.isShowMenu = !this.isShowMenu;
    },
    launchPageFlag () {
      this.setHasShowLaunch(true);
    },
    countDown () {
      clearInterval(this.countDownTimer);
      this.countDownTimer = null;
      this.countDownTimer = setInterval(() => {
        if (this.countDownTime > 0) {
          this.countDownTime--;
        } else {
          clearInterval(this.countDownTimer);
          this.countDownTimer = null;
          this.launchPageFlag();
        }
      }, 1000);
    },
    shorVideoSearch () {
      this.$router.push('/shorVideoSearch');
    },
    download () {
      this.$router.push('/download');
    },
    search () {
      this.shorVideoSearch();
      // if (this.selectKey === 0) {
      //   this.$router.push('/longVideoSearch');
      // } else if (this.selectKey === 1) {
      //   this.shorVideoSearch();
      // } else if (this.selectKey === 2) {
      //   this.$router.push('/novel/search');
      // }
    },
    changeIndex (index) {
      this.selectKey = index;
    }
  }
};
</script>

<style lang="scss" scoped>
.home {
  height: calc(100% - 78px);
  background-color: #070709;

  .header {
    position: fixed;
    top: 0;
    z-index: 3;
    display: flex;
    align-items: center;
    width: 100%;

    i {
      width: 24px;
      height: 24px;
      background-size: 100% 100%;
    }

    .search-icon {
      position: absolute;
      top: 18px;
      right: 16px;
      background-image: url("~@assets/imgs/public/searchIcon.png");
    }

    //.logo {
    //  position: absolute;
    //  top: 18px;
    //  right: 4px;
    //  width: 89px;
    //  height: 30px;
    //  background: url("assets/logo.png") 0 0/100% 100%;
    //}

    .tab {
      position: absolute;
      top: 18px;
      //left: 108px;
      left: 50%;
      transform: translateX(-50%);
      white-space: nowrap;

      .item {
        text-transform: capitalize;
        margin-right: 16px;
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 16px;
        text-align: center;
        color: rgba(255, 255, 255, 0.8);

        &:last-of-type {
          margin-right: 0;
        }

        &.active {
          position: relative;
          color: #FFF;
          font-size: 20px;
          &:after {
            position: absolute;
            left: 50%;
            bottom: -9px;
            transform: translateX(-50%);
            content: '';
            width: 22px;
            height: 2px;
            background: #FFF;
          }
        }
      }
    }

    .first-menu {
      position: absolute;
      top: 18px;
      left: 16px;
      // width: 22px;

      .text {
        height: 22px;
        color: #fff;
        display: flex;
        align-items: center;
        gap: 3px;
      }
      .add {
        width: 22px;
        height: 22px;
        background: url("./assets/addIcon.png") 0 0/100% 100%;
        color: #fff;
      }

      .second-menu {
        position: relative;
        top: 6px;
        left: -3px;
        width: 150px;
        //padding: 0 10px;
        height: 0;
        overflow: hidden;
        background: #FFF;
        border-radius: 6px;
        transition: all 0.15s ease-out;
        &.show {
          overflow: unset;
          height: 100%;
          .item {
            opacity: 1;
          }
        }

        &.isZh {
          width: 116px;
        }

        &.show140 {
          height: 140px;
          overflow: unset;

          .item {
            opacity: 1;
          }
        }

        &.show93 {
          //height: 93px;
          height: 46px;
          overflow: unset;

          .item {
            opacity: 1;
          }
        }

        &:before {
          content: '';
          position: absolute;
          top: -12px;
          left: 6px;
          display: block;
          border-style: solid;
          border-top-width: 6px;
          border-bottom-width: 6px;
          border-left-width: 8px;
          border-right-width: 8px;
          border-top-color: transparent;
          border-bottom-color: #FFF;
          border-left-color: transparent;
          border-right-color: transparent;
        }

        .item {
          display: flex;
          align-items: center;
          height: 46px;
          opacity: 0;
          transition: all 0.2s ease-out;

          img {
            width: 22px;
            height: 22px;
            margin-right: 7px;
            margin-left: 10px;
          }

          span {
            font-family: 'PingFang SC';
            font-weight: 500;
            font-size: 13px;
            line-height: 13px;
            color: rgba(22, 22, 22, 0.9);
          }
        }
      }
    }
  }

  .main {
    height: 100%;
  }

  .launch-page {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10001;
    display: flex;
    flex-direction: column;
    align-items: center;
    //justify-content: center;
    width: 100%;
    height: 100%;
    padding-top: 100px;
    background-size: 100% 100%;

    .launch-bg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: -1;
      object-fit: cover;
    }

    .logo {
      width: 90px;
      height: 90px;
      margin-bottom: 20px;
    }

    .title1 {
      height: 53px;
    }

    .title2, .title3 {
      height: 18px;
    }

    .current-time {
      font-size: 42.5px;
      color: #fff;
      margin-top: 10px;
      margin-bottom: 7px;
      font-family: "PingFang SC", "Helvetica Neue", Helvetica, STHeiTi, Arial, sans-serif;
      letter-spacing: 6px;
    }

    .count-down {
      position: absolute;
      top: 20px;
      right: 20px;
      width: 40px;
      height: 40px;
      font-size: 18px;
      border-radius: 50%;
      text-align: center;
      line-height: 40px;
      font-weight: 500;
      text-space: 3px;
      //background-color: lightslategray;
      color: #FFF;
    }

    .enter {
      position: absolute;
      top: 20px;
      right: 20px;
      width: 40px;
      height: 40px;
      font-size: 18px;
      font-weight: 500;
      text-align: center;
      line-height: 40px;
      color: #FFF;
    }
  }
}
</style>
